import * as React from 'react';

import { MENTEE_NAVIGATION } from '../mentee/navigation';
import { MENTOR_NAVIGATION } from '../mentor/navigation';
import {
  MentorshipMemberRole,
  useMentorshipContext,
} from './context/useMentorshipContext';

const PRE_ONBOARDING_MODULES = new Set([
  'dashboard',
  'profile',
  'programs',
  'notifications',
]);

export const useMentorshipNavigation = (
  role: MentorshipMemberRole,
  enabled = true
) => {
  const { context } = useMentorshipContext(enabled);
  const onboarded =
    role === 'mentor'
      ? context?.mentorOnboarded === true
      : context?.menteeOnboarded === true;
  const items = role === 'mentor' ? MENTOR_NAVIGATION : MENTEE_NAVIGATION;

  return React.useMemo(
    () =>
      items.map((item) => {
        const disabled =
          enabled && !onboarded && !PRE_ONBOARDING_MODULES.has(item.key);
        return {
          ...item,
          disabled,
          disabledReason: disabled
            ? 'Available after you are onboarded to a Workspace.'
            : undefined,
        };
      }),
    [enabled, items, onboarded]
  );
};
